import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Trans, withTranslation } from 'react-i18next';
import { withRouter, BrowserRouter as Router } from 'react-router-dom';
import { connect, Provider } from 'react-redux';
import MenuItem from 'material-ui/MenuItem';
import RenderToLayer from 'material-ui/internal/RenderToLayer';
import { SimpleToolbar } from '../../../../../../../app/modules/toolbar';
import { store } from '../../../../../../../';
import { CircularProgress } from '../../../../../../../app/components/progress';
import { RaisedButton } from '../../../../../../../app/components/buttons';
import SelectField from '../../../../../../../app/components/selectField';

import {
  closeDuplicateComponentDialog,
  setPageSelect,
  duplicateComponent,
} from './actions';
import themeStyles from '../../../../../../../_export.scss';

const styles = {
  buttonRoot: {
    margin: '12px',
    width: '200px',
  },
  buttonFlat: {
    margin: '12px',
    width: '150px',
    boxShadow: 'none',
  },
  CancelLabelStyle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: themeStyles.secondaryTextColor,
    textTransform: 'capitalize',
  },
  NextLabelStyle: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: themeStyles.primaryTextColor,
    textTransform: 'capitalize',
  },
};

class DuplicateComponent extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onTitleChange: PropTypes.func.isRequired,
    pages: PropTypes.array.isRequired,
    onPageSelect: PropTypes.func.isRequired,
  };

  dropdownNavigationOptions = () => {
    const formattedPages = [];
    let pagesToExclude = [];

    this.props.pages.map((page, index) => {
      if (page.tabs) {
        page.tabs.map((item, key) => {
          formattedPages.push({
            title: item.title,
            key:
              page.type === 'TabView'
                ? `tab/${page.key}/${key}`
                : `${page.key}/${page.parentPageKey}/${key}`,
          });
        });
      } else {
        let pageKey = page.key;
        if (page.type === 'NestedPage') {
          pageKey = `${page.key}/${page.parentPageKey}`;
          pagesToExclude = [...pagesToExclude, page.parentPageKey];
        }

        formattedPages.push({ title: page.title, key: pageKey });
      }
    });

    const filteredPages = formattedPages.filter(
      item => !pagesToExclude.includes(item.key),
    );
    return filteredPages.map((page, index) => (
      <MenuItem key={page.key} value={page.key} primaryText={page.title} />
    ));
  };

  renderLayer = () => {
    const { form, onCancel, onSubmit, onTitleChange, t } = this.props;

    const pendingIndicator = form.pending ? (
      <CircularProgress size={20} thickness={3} />
    ) : null;
    const displayError = form.error ? <p>{form.error}</p> : null;

    const buttonCancel =
      !form.pending && onCancel ? (
        <RaisedButton
          label={t('Cancel')}
          onClick={onCancel}
          disabled={form.pending}
          backgroundColor={themeStyles.mainWhite}
          disabledBackgroundColor={themeStyles.mainGrey}
          style={styles.buttonFlat}
          labelStyle={styles.CancelLabelStyle}
        />
      ) : null;

    const buttonContinue = !form.pending ? (
      <RaisedButton
        label={t('Submit')}
        onClick={onSubmit}
        disabled={!form.selectedPage}
        backgroundColor={themeStyles.primaryColor}
        disabledBackgroundColor={themeStyles.primaryColorLight}
        style={styles.buttonRoot}
        labelStyle={styles.NextLabelStyle}
      />
    ) : null;

    return (
      <Router>
        <div className="overlay create-page">
          <Provider store={store}>
            <SimpleToolbar onExit={onCancel} />
          </Provider>
          <div className={`create-content`}>
            <h2>
              <Trans>Duplicate Component</Trans>
            </h2>
            <div className="create-form">
              <div key="standardForm">
                {/* <TextField
                  id="page_title"
                  {...form.title}
                  onChange={onTitleChange}
                  placeholder="Page Title"
                /> */}
                <SelectField
                  label={t('Select Page to Duplicate to')}
                  value={this.props.form.selectedPage}
                  options={this.dropdownNavigationOptions()}
                  onChange={(i, val) => {
                    this.props.onPageSelect(val);
                  }}
                />
              </div>
            </div>
            <div className="buttons-container flex-row">
              {buttonCancel}
              {pendingIndicator}
              {buttonContinue}
            </div>
            <div> {displayError} </div>
          </div>
        </div>
      </Router>
    );
  };

  render() {
    return (
      <RenderToLayer
        open={this.props.form.open}
        render={this.renderLayer}
        useLayerForClickAway={false}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const layout = state.editor.data.layoutData[ownProps.match.params.appname];

  return {
    ...ownProps,
    form: state.editor.build.create.duplicateComponent,
    pages: layout
      ? layout.childRoutes.map(key => state.editor.data.alwaysData[key])
      : [],
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const router = {
    history: ownProps.history,
    location: ownProps.location,
    match: ownProps.match,
  };
  return {
    onSubmit: () =>
      dispatch(duplicateComponent(ownProps.match.params.appname, router)),
    onCancel: () => dispatch(closeDuplicateComponentDialog()),
    onPageSelect: val => dispatch(setPageSelect(val)),
  };
};

export default withTranslation()(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DuplicateComponent)),
);
